import _ from 'lodash';
import { gotoOverdue, logOut } from 'common/services/auth.service';
import {
  destroyAccountSucceed,
  fetchAccountFailure,
  fetchAccountsSucceed,
  fetchAccountSucceed,
  sendAccountInvitationFailure,
  sendAccountInvitationSucceed,
  updateAccountSucceed
} from '../actions';
import {
  getAccount,
  getAccounts as getAccountsApi,
  updateAccount,
  deleteAccount,
  updatePinnedDashboards,
  changeAccountType
} from 'common/services/account.service';
import { accountInvitation } from 'common/services/invitations.service';
import { validateGdprAgreement } from 'common/services/gdpr.service';

export const getAccountByToken = () => async dispatch => {
  try {
    const account = await getAccount();
    if (!validateGdprAgreement(account)) {
      // no GDPR privacy-policy agreement accepted yet
      return logOut();
    }
    dispatch(fetchAccountSucceed(account));
    return account;
  } catch (e) {
    return validateFetchAccountError(e);
  }
};

export const validateFetchAccountError = httpError => {
  const tykKeyNotAuthorized = _.get(
    httpError,
    'response.data.error',
    ''
  ).startsWith('Key not authorized');
  const statusCode = _.get(httpError, 'response.status', 0);

  if (statusCode === 403 && !tykKeyNotAuthorized) {
    return gotoOverdue();
  }

  if (statusCode === 404 || statusCode === 401) {
    return logOut();
  }
};

export const patchAccount = (id, payload) => async dispatch => {
  try {
    const account = await updateAccount(id, payload);
    dispatch(fetchAccountSucceed(account));
  } catch (e) {
    dispatch(fetchAccountFailure(e));
    throw e;
  }
};

export const updatePinnedBoards = payload => async dispatch => {
  try {
    await updatePinnedDashboards(payload);
    const account = await getAccount();
    dispatch(fetchAccountSucceed(account));
  } catch {}
};

export const getAccounts = () => async dispatch => {
  try {
    const accounts = await getAccountsApi();
    dispatch(fetchAccountsSucceed(accounts));
  } catch (e) {}
};

export const sendAccountInvitation =
  (payload = {}) =>
  async dispatch => {
    try {
      const invitation = await accountInvitation(payload);
      dispatch(sendAccountInvitationSucceed(invitation));

      return invitation;
    } catch (e) {
      dispatch(sendAccountInvitationFailure(e));

      throw e;
    }
  };

export const destroyAccount = id => async dispatch => {
  await deleteAccount(id);
  dispatch(
    destroyAccountSucceed({
      id
    })
  );
};

export const changeUserAccountType =
  ({ id, type_id }) =>
  async dispatch => {
    try {
      const account = await changeAccountType(id, {
        type_id
      });
      dispatch(updateAccountSucceed(account));
    } catch (e) {}
  };
